import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ExternalMerchantNewpasswordPage } from './external-merchant-newpassword.page';

const routes: Routes = [
  {
    path: '',
    component: ExternalMerchantNewpasswordPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ExternalMerchantNewpasswordPageRoutingModule {}
